/**
 * Returns a function that will only be called once every n milliseconds
 *
 * @param fn
 * @param delay
 * @return {function(...[*])}
 */
export default function debounce(fn, delay) {
    if (typeof fn !== 'function') {
        throw new Error('Debounce requires a callback function');
    }

    if (isNaN(delay)) {
        throw new Error('Debounce requires a delay');
    }

    let timeout;

    return (...args) => {
        const later = () => {
            timeout = null;
            return fn(...args);
        };

        clearTimeout(timeout);
        timeout = setTimeout(later, delay);
    };
}
